import { useGameStore } from '@/store/gameStore';

/**
 * スコア表示コンポーネント
 * PIXIキャンバス上にオーバーレイ表示する
 */
export function ScoreDisplay() {
  const { score } = useGameStore();

  return (
    <p className="absolute top-20 right-20 z-10 pointer-events-none select-none text-yellow-400 text-2xl font-bold">
      スコア: {score}
    </p>
  );
}
